export const container = {
    pageToolbar: {
        collection_data: 'נתוני גבייה',
        contacts: 'יצירת קשר',
        maintenance: 'פעולות דייר',
        soon: 'בקרוב',
        clientChat: 'עוזרת אישית',
        marketplace: 'מומלצים',
    },
    changeApartment: 'החלף דירה',
}
